import { Button } from '@mui/material';
import React from 'react';
import { renew } from 'src/utils/contracts/registrar';
import { handleError } from 'src/utils/errors/common';

const Renewal: React.FC<{
  label: string;
  renewalPeriod: number;
  token: Token;
  renewalCost: number;
  onValueChange: (renewalPeriod: number) => void;
}> = ({ label, renewalPeriod, token, renewalCost, onValueChange }) => {
  const renewDomain = async () => {
    try {
      await renew(label, renewalPeriod, token.tokenAddress, renewalCost);
      onValueChange(renewalPeriod);
    } catch (error) {
      handleError(error, 'Failed to renew domain.');
    }
  };

  return (
    <Button
      variant="contained"
      onClick={renewDomain}
      sx={{
        color: 'text.primary',
        backgroundColor: 'primary.main',
        padding: '10px 16px',
      }}
    >
      Renew for {renewalCost} {token.symbol}
    </Button>
  );
};

export default React.memo(Renewal);
